<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem?.displayName }} [{{ currentItem?.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showSave]="manageIndustries && (currentItem?.canUpdate == true || !currentItem?.resourceId) && currentItem && !plantLocked"
          [showAddToFavorites]="!favoriteId && currentItem && currentItem.resourceId"
          [showRemoveFromFavorites]="favoriteId"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="manageIndustries && (currentItem?.canUpdate == true || !currentItem?.resourceId) && currentItem && currentItem.resourceId"
          [showShare]="manageIndustries && (currentItem?.canUpdate == true || !currentItem?.resourceId) && currentItem && currentItem.resourceId"
          (onSave)="clickSave(currentItem)"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onDuplicate)="onDuplicate(currentItem.resourceId!)"
          (onDelete)="openDialogDelete(currentItem.resourceId!)"
          (onShare)="onShare(currentItem.resourceId!)"></action-bar>
      </div>
    </div>

    <!-- FDES — statut usine (enrobés enregistrées) -->
    <div class="fdes-scope" *ngIf="isSaved && isCoating">
      <div class="fdes-plant">
        <div class="fdes-plant__status">
          <span class="seve-badge seve-badge--neutral" *ngIf="!savedPlantIsCustom"><span class="seve-badge__dot"></span>{{ 'industrie_fdes_badge_default_plant' | translate }}</span>
          <span class="seve-badge seve-badge--info" *ngIf="savedPlantIsCustom && plantStatus === 'validated'"><span class="seve-badge__dot"></span>{{ 'industrie_fdes_badge_custom_validated' | translate }}</span>
          <span class="seve-badge seve-badge--warn" *ngIf="savedPlantIsCustom && plantStatus === 'pending'"><span class="seve-badge__dot"></span>{{ 'industrie_fdes_badge_custom_pending' | translate }}</span>
          <span class="seve-spacer"></span>
          <span class="fdes-plant__validated" *ngIf="currentItem?.validatedDate">{{ 'industrie_fdes_validated_on' | translate }} {{ currentItem?.validatedDate | date: 'dd/MM/yyyy' }}</span>
          <button *ngIf="isPlantValidated && !editingPlant" type="button" class="seve-btn seve-btn--secondary seve-btn--sm" (click)="startEdit()"><mat-icon>edit</mat-icon>{{ 'common_modify' | translate }}</button>
          <button *ngIf="isPlantValidated && !editingPlant && canValidateCustomIndustry" type="button" class="seve-btn seve-btn--danger seve-btn--sm" (click)="forceDefaultPlant()">
            <mat-icon>restart_alt</mat-icon>{{ 'industrie_fdes_force_default' | translate }}
          </button>
        </div>

        <!-- header row (icon + message + action) then, when there is one, the diff spanning underneath:
             the icon and the button stay centred on the MESSAGE, not on a box that grows with the diff -->
        <div class="seve-banner seve-banner--alert fdes-pending" *ngIf="savedPlantIsCustom && plantStatus === 'pending'">
          <div class="fdes-pending__head">
            <span class="seve-banner__ic"><mat-icon>schedule</mat-icon></span>
            <p class="fdes-pending__message">
              <strong>{{ 'industrie_fdes_pending_banner_strong' | translate }}</strong> {{ 'industrie_fdes_pending_banner_text' | translate }}
            </p>
            <button type="button" class="seve-btn seve-btn--danger seve-btn--sm" (click)="cancelPlantRequest()"><mat-icon>delete_outline</mat-icon>{{ 'industrie_fdes_delete_request' | translate }}</button>
          </div>

          <!-- the fields shown above stay the ones in USE; what the request would change is listed here -->
          <div class="fdes-pending__changes" *ngIf="pendingChanges.length || pendingFileChanges.length">
            <span class="fdes-pending__changes-title">{{ 'industrie_fdes_pending_changes_title' | translate }}</span>
            <dl class="fdes-pending__list">
              <ng-container *ngFor="let change of pendingChanges">
                <dt class="fdes-pending__label">{{ change.labelKey | translate }}</dt>
                <dd class="fdes-pending__value">
                  <span class="fdes-pending__old">{{ change.before }}</span>
                  <mat-icon class="fdes-pending__arrow">arrow_right_alt</mat-icon>
                  <span class="fdes-pending__new">{{ change.after }}</span>
                </dd>
              </ng-container>
              <ng-container *ngFor="let file of pendingFileChanges">
                <dt class="fdes-pending__label">{{ file }}</dt>
                <dd class="fdes-pending__value">
                  <span class="fdes-pending__chip"><mat-icon>attach_file</mat-icon>{{ 'industrie_fdes_pending_file_updated' | translate }}</span>
                </dd>
              </ng-container>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <div [class.disabled-form]="formDisabled">
      <div class="identification">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="10" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'ref_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" required />
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.owner.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.creator.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <div class="title-margin-top">
        <div>
          <h3>{{ 'industrie_section' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_family' | translate }}</mat-label>
                  <mat-select formControlName="familyId" required (selectionChange)="checkIsCoating($event.value)">
                    <mat-option *ngFor="let f of families" [value]="f.familyId"> {{ f.displayName }} [{{ f.code }}] </mat-option>
                  </mat-select>
                  <mat-error *ngIf="formCrls.familyId.invalid">{{ 'industrie_error_family_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4" *ngIf="isCoating">
                <mat-checkbox formControlName="mobileStation"> {{ 'industrie_checkbox_mobile_station' | translate }} </mat-checkbox>
              </div>
            </div>
          </mat-card>
        </div>

        <!-- FDES — type d'usine / personnalisation (uniquement Usine d'enrobés, après la famille) -->
        <div class="fdes-scope fdes-after-family" *ngIf="isCoating">
          <div class="fdes-plant">
            <div class="seve-card fdes-typechoice" *ngIf="!isSaved">
              <div class="seve-card__head">
                <span class="seve-eyebrow">{{ 'industrie_fdes_plant_type_title' | translate }}</span>
              </div>
              <div class="seve-card__body">
                <div class="seve-grid seve-grid--2">
                  <label class="fdes-typecard" [class.fdes-typecard--active]="plantType === 'default'">
                    <span class="seve-radio">
                      <input type="radio" name="plantType" value="default" [(ngModel)]="plantType" [ngModelOptions]="{ standalone: true }" />
                      <span class="fdes-typecard__title">{{ 'industrie_fdes_default_plant_title' | translate }}</span>
                    </span>
                    <span class="fdes-typecard__desc">{{ 'industrie_fdes_default_plant_desc' | translate }}</span>
                  </label>
                  <label class="fdes-typecard" [class.fdes-typecard--active]="plantType === 'custom'" *ngIf="canCreateCustomIndustry">
                    <span class="seve-radio">
                      <input type="radio" name="plantType" value="custom" [(ngModel)]="plantType" [ngModelOptions]="{ standalone: true }" />
                      <span class="fdes-typecard__title">{{ 'industrie_fdes_custom_plant_title' | translate }}</span>
                    </span>
                    <span class="fdes-typecard__desc">{{ 'industrie_fdes_custom_plant_desc' | translate }}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="fdes-personnaliser" *ngIf="isSaved && !savedPlantIsCustom && !customizing && canCreateCustomIndustry && manageIndustries && (currentItem?.canUpdate == true || !currentItem?.resourceId)">
              <button type="button" class="seve-btn seve-btn--secondary" (click)="startCustomize()"><mat-icon>tune</mat-icon>{{ 'industrie_fdes_customize_default_plant' | translate }}</button>
              <span class="fdes-personnaliser__hint">{{ 'industrie_fdes_customize_hint' | translate }}</span>
            </div>

            <ng-container *ngIf="showUploads">
              <div class="seve-banner seve-banner--info fdes-banner">
                <span class="seve-banner__ic"><mat-icon>info</mat-icon></span>
                <div class="fdes-banner__text">
                  {{ 'industrie_fdes_info_banner_p1' | translate }} <strong>{{ 'industrie_fdes_info_banner_request' | translate }}</strong
                  >. {{ 'industrie_fdes_info_banner_p2' | translate }} <strong>{{ 'industrie_fdes_info_banner_pending' | translate }}</strong> {{ 'industrie_fdes_info_banner_p3' | translate }}
                  <strong>{{ 'industrie_fdes_info_banner_mandatory' | translate }}</strong
                  >.
                </div>
              </div>

              <div class="seve-grid seve-grid--2 fdes-uploads">
                <div class="fdes-upload" [class.fdes-upload--filled]="xlsFileName" (click)="attachXls()">
                  <input #xlsFileInput type="file" accept=".xlsx" hidden (change)="onXlsFileSelected($event)" />
                  <span class="fdes-upload__chip fdes-upload__chip--xls"><mat-icon>description</mat-icon></span>
                  <div class="fdes-upload__body">
                    <div class="fdes-upload__title">{{ 'industrie_fdes_upload_excel_title' | translate }} <span class="fdes-upload__req">*</span></div>
                    <div class="fdes-upload__hint">{{ xlsFileName || ('industrie_fdes_upload_excel_hint' | translate) }}</div>
                  </div>
                  <mat-icon class="fdes-upload__state fdes-upload__state--dl" *ngIf="xlsFromServer && xlsFileName" (click)="$event.stopPropagation(); downloadXls()" [title]="'industrie_validation_download_btn' | translate">download</mat-icon>
                  <mat-icon class="fdes-upload__state" *ngIf="!(xlsFromServer && xlsFileName)">{{ xlsFileName ? 'check_circle' : 'cloud_upload' }}</mat-icon>
                </div>
                <div class="fdes-upload" [class.fdes-upload--filled]="pdfFileName" (click)="attachPdf()">
                  <input #pdfFileInput type="file" accept=".pdf" hidden (change)="onPdfFileSelected($event)" />
                  <span class="fdes-upload__chip fdes-upload__chip--pdf"><mat-icon>picture_as_pdf</mat-icon></span>
                  <div class="fdes-upload__body">
                    <div class="fdes-upload__title">{{ 'industrie_fdes_upload_pdf_title' | translate }} <span class="fdes-upload__req">*</span></div>
                    <div class="fdes-upload__hint">{{ pdfFileName || ('industrie_fdes_upload_pdf_hint' | translate) }}</div>
                  </div>
                  <mat-icon class="fdes-upload__state fdes-upload__state--dl" *ngIf="pdfFromServer && pdfFileName" (click)="$event.stopPropagation(); downloadPdf()" [title]="'industrie_validation_download_btn' | translate">download</mat-icon>
                  <mat-icon class="fdes-upload__state" *ngIf="!(pdfFromServer && pdfFileName)">{{ pdfFileName ? 'check_circle' : 'cloud_upload' }}</mat-icon>
                </div>
              </div>
              <span class="seve-error" *ngIf="uploadsError || fileError" style="white-space: pre-line">{{ fileError || ('industrie_fdes_uploads_required_error' | translate) }}</span>
            </ng-container>

            <!-- Une fois la demande traitée, elle quitte l'écran de validation : c'est ici que les
                 justificatifs de l'usine restent consultables. -->
            <div class="seve-card" *ngIf="!showUploads && hasCustomFiles">
              <div class="seve-card__head">
                <span class="seve-eyebrow">{{ 'industrie_validation_eyebrow_documents' | translate }}</span>
              </div>
              <div class="seve-card__body">
                <div class="seve-grid seve-grid--2">
                  <div class="fdes-upload fdes-upload--readonly" *ngIf="energyProfile?.excelName">
                    <span class="fdes-upload__chip fdes-upload__chip--xls"><mat-icon>description</mat-icon></span>
                    <div class="fdes-upload__body">
                      <div class="fdes-upload__title">{{ 'industrie_fdes_upload_excel_title' | translate }}</div>
                      <div class="fdes-upload__hint">{{ energyProfile?.excelName }}</div>
                    </div>
                    <mat-icon class="fdes-upload__state resetPointerEvents" (click)="downloadXls()" [title]="'industrie_validation_download_btn' | translate">download</mat-icon>
                  </div>
                  <div class="fdes-upload fdes-upload--readonly" *ngIf="energyProfile?.pdfName">
                    <span class="fdes-upload__chip fdes-upload__chip--pdf"><mat-icon>picture_as_pdf</mat-icon></span>
                    <div class="fdes-upload__body">
                      <div class="fdes-upload__title">{{ 'industrie_fdes_upload_pdf_title' | translate }}</div>
                      <div class="fdes-upload__hint">{{ energyProfile?.pdfName }}</div>
                    </div>
                    <mat-icon class="fdes-upload__state resetPointerEvents" (click)="downloadPdf()" [title]="'industrie_validation_download_btn' | translate">download</mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="title-margin-top">
          <h3>{{ 'industrie_section_address' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-4">
                <mat-form-field>
                  <mat-label color="accent">{{ 'agency_field_address_line1' | translate }}</mat-label>
                  <input formControlName="address_L3" maxlength="100" matInput required />
                  <mat-error *ngIf="formCrls.address_L3.invalid">{{ 'industrie_fdes_field_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <mat-form-field>
                  <mat-label color="accent">{{ 'agency_field_address_line2' | translate }}</mat-label>
                  <input formControlName="address_L4" maxlength="100" matInput />
                </mat-form-field>
              </div>
              <div class="col-4">
                <mat-form-field>
                  <mat-label color="accent">{{ 'agency_field_address_line3' | translate }}</mat-label>
                  <input formControlName="address_L5" maxlength="100" matInput />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <mat-form-field>
                  <mat-label color="accent">{{ 'agency_field_postal_code' | translate }}</mat-label>
                  <input matInput formControlName="address_PC" type="number" required />
                  <mat-error *ngIf="formCrls.address_PC.invalid">{{ 'industrie_fdes_field_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field>
                  <mat-label color="accent">{{ 'agency_field_city' | translate }}</mat-label>
                  <input matInput formControlName="address_Location" required />
                  <mat-error *ngIf="formCrls.address_Location.invalid">{{ 'industrie_fdes_field_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>

        <div *ngIf="isFormulation" [class]="{ 'disabled-form': !acuView }">
          <div class="title title-margin-top">
            <h3>{{ 'ref_section_env_cost_ton' | translate }}</h3>
          </div>
          <mat-card formGroupName="ceu">
            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input matInput type="number" [value]="formCrls.ceu.get('en')?.value" (change)="setValue($event.target, 'en')" />
                  <mat-error *ngIf="formCrls.ceu?.get('en')?.invalid">{{ 'ref_error_energy_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input matInput type="number" [value]="formCrls.ceu.get('co')?.value" (change)="setValue($event.target, 'co')" />
                  <mat-error *ngIf="formCrls.ceu?.get('co')?.invalid">{{ 'ref_error_co2_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_natural_aggregates' | translate }}</mat-label>
                  <input matInput type="number" [value]="formCrls.ceu.get('gn')?.value" (change)="setValue($event.target, 'gn')" />
                  <mat-error *ngIf="formCrls.ceu?.get('gn')?.invalid">{{ 'ref_error_aggregates_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_coated_aggregates' | translate }}</mat-label>
                  <input matInput type="number" [value]="formCrls.ceu.get('ae')?.value" (change)="setValue($event.target, 'ae')" />
                  <mat-error *ngIf="formCrls.ceu?.get('ae')?.invalid">{{ 'ref_error_coated_aggregates_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_recycled_materials' | translate }}</mat-label>
                  <input matInput type="number" [value]="formCrls.ceu.get('mr')?.value" (change)="setValue($event.target, 'mr')" />
                  <mat-error *ngIf="formCrls.ceu?.get('mr')?.invalid">{{ 'ref_error_materials_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_reused_spoils' | translate }}</mat-label>
                  <input matInput type="number" [value]="formCrls.ceu.get('drc')?.value" (change)="setValue($event.target, 'drc')" />
                  <mat-error *ngIf="formCrls.ceu?.get('drc')?.invalid">{{ 'ref_error_spoils_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <span *ngIf="formCrls.ceu?.invalid" class="mat-error">
                  {{ 'ref_error_indicators_required' | translate }}
                </span>
              </div>
            </div>
          </mat-card>
        </div>

        <div *ngIf="isCoating && !isCustomPlant">
          <div class="title title-margin-top">
            <h3>{{ 'industrie_section_combustible' | translate }}</h3>
            <button mat-mini-fab (click)="addCombustible()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
          <mat-card *ngIf="hasCombustibles">
            <div>
              <div class="row">
                <div class="col-12">
                  <table #tableCombustibles mat-table [dataSource]="formCrls?.combustibles?.value || []" class="table-combustible col-12">
                    <ng-container matColumnDef="code">
                      <th mat-header-cell *matHeaderCellDef>{{ 'common_field_code' | translate }}</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element?.combustibleCode }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="displayName">
                      <th mat-header-cell *matHeaderCellDef>{{ 'common_field_label' | translate }}</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element?.combustibleName }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="value">
                      <th mat-header-cell *matHeaderCellDef>{{ 'industrie_fdes_combustible_usage_pct' | translate }}</th>
                      <td mat-cell *matCellDef="let element">
                        <span class="fdes-combustible-pct">{{ element?.value || 0 }} %</span>
                        <mat-icon class="fdes-combustible-edit" (click)="editCombustibleValue(element)">edit</mat-icon>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="delete">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element; let i = index">
                        <mat-icon (click)="deleteCombustible(formCrls?.combustibles?.value, i)"> delete</mat-icon>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>
                </div>
              </div>
              <div class="fdes-combustible-total" #combustibleTotalRow>
                <span
                  >{{ 'industrie_fdes_combustible_total_label' | translate }} <strong [class.fdes-combustible-total--ko]="!combustibleValid">{{ combustibleTotal }} %</strong></span
                >
                <span class="mat-error" *ngIf="!combustibleValid">{{ 'industrie_fdes_combustible_total_error' | translate }}</span>
              </div>
            </div>
          </mat-card>
        </div>

        <div class="fdes-scope" *ngIf="isSaved && isCoating && hasEnergyData">
          <div class="seve-card fdes-energy">
            <div class="seve-card__head">
              <span class="seve-eyebrow seve-eyebrow--green">{{ 'industrie_section_energy' | translate }}</span>
            </div>
            <div class="seve-card__body fdes-energy__body">
              <app-fdes-thermal-card
                class="fdes-energy__card"
                [conso]="thermalConso"
                [consoUnit]="energyProfile?.consoUnit || 'MJ/t'"
                [elec]="energyProfile?.ratios?.elec || 0"
                [gnr]="energyProfile?.ratios?.gnr || 0"
                [comb]="energyProfile?.ratios?.combustibles || 0"
                [combustibles]="thermalCombustibles"
                [feUnit]="energyProfile?.feUnit || 'kgCO2e/MJ'"></app-fdes-thermal-card>
              <div class="fdes-energy__hint"><mat-icon>lock</mat-icon>{{ 'industrie_energy_readonly_hint' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
